export default __webpack_public_path__ + "static/media/389.506f0305.png";